import { render, staticRenderFns } from "./MGT.vue?vue&type=template&id=b62d0f28&scoped=true"
import script from "./MGT.vue?vue&type=script&lang=js"
export * from "./MGT.vue?vue&type=script&lang=js"
import style0 from "./MGT.vue?vue&type=style&index=0&id=b62d0f28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62d0f28",
  null
  
)

export default component.exports